import type { UserProfile } from '@bambi/api-client/schemas';

import type { RootState } from 'src/app/store/types';

function pluckOrganizationById(profile: UserProfile, id: string) {
  return profile.memberships.find((membership) => {
    return membership.organization.id === id;
  })?.organization;
}

export function selectSendbirdAppId(state: RootState) {
  if (!state.auth.profile) return;

  if (state.auth.currentOrganizationId) {
    const organization = pluckOrganizationById(
      state.auth.profile,
      state.auth.currentOrganizationId
    );

    return organization?.chat_application_id;
  }
}
export function selectCurrentMembership(state: RootState) {
  if (!state.auth.profile) return;

  if (state.auth.currentOrganizationId) {
    return state.auth.profile.memberships.find((m) => {
      return m.organization.id === state.auth.currentOrganizationId;
    });
  }
}

export function selectCurrentOrganization(state: RootState) {
  if (!state.auth.profile) return;

  if (state.auth.currentOrganizationId) {
    return pluckOrganizationById(
      state.auth.profile,
      state.auth.currentOrganizationId
    );
  }

  // No current org selected — fall back to the first membership. Returns
  // undefined when there are none; must NOT throw, since this runs in
  // RequireAuth above the router's error boundary, so a throw blanks the app.
  return state.auth.profile.memberships[0]?.organization;
}
